// Google Tag Manager loader. Idempotent: calling load() twice is safe.
// Only invoked after the user has granted consent. No <noscript> iframe: GTM
// is injected by JS, so a JS-created noscript fallback could never act.

const DEFAULT_GTM_ID = 'GTM-KH8NXJ7W'
const SCRIPT_ATTR = 'data-helin-gtm'

interface DataLayerWindow extends Window {
  dataLayer?: Array<Record<string, unknown>>
}

export function getGtmId(): string {
  const fromEnv = (import.meta.env.VITE_GTM_ID as string | undefined)?.trim()
  return fromEnv && fromEnv.length > 0 ? fromEnv : DEFAULT_GTM_ID
}

export function isGtmLoaded(): boolean {
  return document.querySelector(`script[${SCRIPT_ATTR}]`) !== null
}

export function loadGtm(id: string = getGtmId()): void {
  if (isGtmLoaded()) return
  if (!id) return

  const w = window as DataLayerWindow
  w.dataLayer = w.dataLayer ?? []
  w.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(id)}`
  script.setAttribute(SCRIPT_ATTR, id)
  document.head.appendChild(script)
}
